import { PaletteMode } from '@mui/material';


const primary = '#f75f02';
const secondary = '#3f835b';

const palette = (mode: PaletteMode) => {
  return {
    mode,
    primary: {
      main: primary,
      light: '#ff8440',
      dark: '#b34701',
      contrastText: '#ffffff',
    },
    divider: '#34372d',
    secondary: {
      main: secondary,
      light: '#78a88c',
      dark: '#2f6244',
      contrastText: '#000000',
    },
    background: {
      default: '#202021',
      paper: '#18191a',
    },
    text: {
      primary: '#CECFD2',
      secondary: '#bbbbbb',
      disabled: '#777777',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
  };
};

export default palette;
